@if (timeRangeConfig) {
  <div
    tabindex="0"
    [attr.aria-label]="config.ariaLabel"
    class="form-control__wrapper--date-range"
  >
    @for (date of ['start', 'end']; track date) {
      <control-text
        [control]="timeRangeForm.get(date)"
        [config]="timeRangeConfig[date]"
      >
      </control-text>
    }
  </div>
}
